import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fkehs24v39: FaireBrandEntity = {
  token: "b_fkehs24v39",
  type: "brand",
  name: "Sweet Lover Fashion",
  avatarUrl:
    "https://cdn.faire.com/fastly/de673cf091815ad15f13500db4082b459362f63992a8c4cf620149802ad10fcf.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3765cfbf4ab2ad960c9449f641598a4ff245a953ae8668272f2e2ae9341ac174.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/de673cf091815ad15f13500db4082b459362f63992a8c4cf620149802ad10fcf.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3765cfbf4ab2ad960c9449f641598a4ff245a953ae8668272f2e2ae9341ac174.jpeg",
  location: "Fairfax, VA, USA",
  minimumOrderDollars: 129,
  rating: 5,
  reviewCount: 20,
  isTopShop: true,
  isInsider: false,
  description:
    "Welcome to Sweetloverfashion!\nWith over 6 years of experience in women's fashion, we are a wholesale company dedicated to providing trendy and high-quality apparel to global retailers. We design and manufacture our products in our factory, ensuring both style and quality at competitive prices. Our collections include dresses, tops, jumpsuits, swimwear, and more—with new styles added daily to keep your inventory fresh and on-trend. At Sweetloverfashion, we make bulk buying easy and reliable for fashion businesses worldwide.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:53.654Z",
    importedBy: "entity-db-cli",
  },
};
